import Bullet from '@/components/global-components/bullet/Bullet';
import BulletDesktopContainer from '@/components/global-components/bullet/sub-components/BulletDesktopContainer';
import Carousel from '@/components/global-components/carousel/Carousel';
import Container from '@/components/global-components/Container';

// Themes
import theme from '@/themes/index';
import { nanoid } from 'nanoid';

const Highlights = ({
  isMobile,
  content, 
}) => {
  const {
    title,
    description,
    highlights, 
  } = content;


  let highlightsForDesktop = [];

  if (!isMobile) {
    highlightsForDesktop = highlights.reduce(
      (accumulator, currentValue, i) =>
        (i % 3
          ? accumulator[accumulator.length - 1].push(currentValue)
          : accumulator.push([currentValue])) && accumulator,
      []
    );
  }

  const getHighlightsForDesktopViewPort = () => {
    let startCardIndex = 0;

    return (
      <>
        <div className='desktop-highlights-container'>
          <Carousel
            cellSpacing={20}
            showButtons={highlightsForDesktop.length > 1}
            showPaging={false}
            containerClassName='highlights-carousel'
          >
            {highlightsForDesktop.map(() => {
              const desktopHighlights = highlights.slice(
                startCardIndex,
                startCardIndex + 3
              );
              startCardIndex += 3;
              return (
                <Container key={nanoid()}>
                  <BulletDesktopContainer
                    bullets={desktopHighlights}
                  />
                </Container>
              );
            })}
          </Carousel>
        </div>
        <style jsx>{`
          div.desktop-highlights-container {
            width: 100%;
          }
        `}</style>
      </>
    );
  };

  const getHighlightsForMobileViewPort = () => (
    <Carousel slidesToShow={1.1} cellSpacing={15} showPaging={true}>
      {highlights.map(({
        highlight,
      }) => (
        <Bullet key={nanoid()} isMobile={isMobile} content={highlight} />
      ))}
    </Carousel>
  );

  return (
    <>
      <div className='container'>
        <div className='title'>
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        <div className='highlights-container'>
          {isMobile
            ? getHighlightsForMobileViewPort()
            : getHighlightsForDesktopViewPort()}
        </div>
      </div>
      <style jsx>{`
        div.container {
          text-align: center;
        }

        div.container p {
          line-height: 1.5rem;
        }

        div.container .title {
          margin-bottom: 1.938rem;
        }

        div.container h3 {
          line-height: 2.5rem;
          margin-block-start: 0.5rem;
          margin-block-end: 0.5rem;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          font-family: ${theme.fontFamilies.montserratSemiBold};
        }

        div.container p {
          margin-block-start: 0;
          margin-block-end: 5rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.container h3 {
            margin-bottom: 1rem;
          }

          div.container p {
            margin-block-end: 4rem;
          }

          div.container .title {
            margin-bottom: 4.938rem;
          }

          div.container div.highlights-container {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
};

export default Highlights;
